const wishlistReducer = (state = [], action) => {
  switch (action.type) {
  case 'GET_WISHLIST':
    if (action.error) return state;
    return { data: action.data.data };

  default:
    return state;
  }
};

export default wishlistReducer;
